import AppController from "./app-controller";

export {AppController};
